import React from 'react';

type BidSummary = {
  price: string;
  gwac: string;
  upb: string;
  settleDate: string;
  ownership?: string;
};

type SellerCounterOfferProps = {
  buyerBid: BidSummary;
  sellerCounteroffer: BidSummary;
  buyerColumnLabel?: string;
  sellerColumnLabel?: string;
};

const SellerCounterOffer = ({
  buyerBid,
  sellerCounteroffer,
  buyerColumnLabel = "Buyer's Bid",
  sellerColumnLabel = 'Your Counteroffer',
}: SellerCounterOfferProps): JSX.Element => {
  return (
    <div className="w-full rounded-md bg-brand-950 p-5 font-mono text-foreground-default">
      <div className="grid grid-cols-3 gap-2 border-b border-slate-500 pb-2 text-sm">
        <span className="text-left text-foreground-default">Details</span>
        <span className="text-right text-foreground-default">{buyerColumnLabel}</span>
        <span className="text-left text-foreground-default">{sellerColumnLabel}</span>
      </div>

      <div className="mt-2 divide-y divide-slate-500 text-sm">
        <div className="grid grid-cols-3 gap-4 py-2">
          <span className="text-left text-foreground-default">Price</span>
          <span className="text-right text-foreground-default">{buyerBid.price}</span>
          <span className="text-left font-bold text-warning-default">
            {sellerCounteroffer.price}
          </span>
        </div>

        <div className="grid grid-cols-3 gap-4 py-2">
          <span className="text-left text-foreground-default">GWAC</span>
          <span className="text-right text-foreground-default">{buyerBid.gwac}</span>
          <span className="text-left text-warning-default">{sellerCounteroffer.gwac}</span>
        </div>

        <div className="grid grid-cols-3 gap-4 py-2">
          <span className="text-left text-foreground-default">UPB</span>
          <span className="text-right text-foreground-default">{buyerBid.upb}</span>
          <span className="text-left text-warning-default">{sellerCounteroffer.upb}</span>
        </div>

        <div className="grid grid-cols-3 gap-4 py-2">
          <span className="text-left text-foreground-default">Settle Date</span>
          <span className="text-right text-foreground-default">{buyerBid.settleDate}</span>
          <span className="text-left text-warning-default">{sellerCounteroffer.settleDate}</span>
        </div>

        {buyerBid.ownership && (
          <div className="grid grid-cols-3 gap-4 py-2">
            <span className="text-left text-foreground-default">Ownership</span>
            <span className="text-right text-foreground-default">{buyerBid.ownership}</span>
            <span className="text-left text-warning-default">
              {sellerCounteroffer.ownership || '-'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerCounterOffer;
